import React, { Component, useEffect } from 'react'
import './App.scss';
import Axios from 'axios';
import config from './Shared/config';
import Token from './Utils/Token';
import { BrowserRouter, Link, Route, Switch, useLocation } from 'react-router-dom';
import Profile from './Components/Profile/Profile';
import Home from './Screens/Home/Home';
import Forum from './Screens/Discussion/Forum';
import Backdoor from './Screens/Backdoor/Backdoor';
import AllTeachers from './Screens/AllTeachers/AllTeachers';
import TeacherProfile from './Screens/Teacher/TeacherProfile';
import OnlineClassList from './Screens/OnlineClassList/OnlineClassList';
import OnlineListings from './Screens/OnlineListings/OnlineListings';
import Post from './Screens/Post/Post';
export default class App extends Component {

	constructor(props) {
		super(props)

		this.state = {
			user: null,
			parentInfoAlertClosedByUser: false
		}
	}

	ScrollToTop = () => {
		const { pathname } = useLocation();

		useEffect(() => {
			window.scrollTo(0, 0);
		}, [pathname]);

		return null;
	}

	componentDidMount() {
		const url = config.apiUrl + '/Authentication/getUser'
		const token = Token.getToken()
		if (token) {
			Axios.get(url).then(res => {
				if (res.data.error) {
					Token.deleteToken();
					window.location.reload();
				} else {
					this.setState({
						user: res.data.data
					})
				}
			}).catch(err => {

			})
		}
	}

	closeParentInfoAlert = () => {
		this.setState({
			parentInfoAlertClosedByUser: true
		})
	}

	render() {

		let { user, parentInfoAlertClosedByUser } = this.state
		let parentInfoSaved = user ? (user.parentInfoSaved || false) : true

		return (
			<div className="App">
				<BrowserRouter>
					<this.ScrollToTop />

					<Switch>
						<Route path='/' exact={true} render={(props) => <Home />} />
						<Route path='/discussion' exact={true} render={(props) => <Forum {...props} />} />
						<Route path='/profile' exact={true} render={(props) => <Profile closeParentInfoAlert={this.closeParentInfoAlert} {...props} />} />
						<Route path='/post/:id' exact={true} render={(props) => <Post {...props} />} />
						<Route path='/teacher/:id' exact={true} render={(props) => <TeacherProfile {...props} />} />
						<Route path='/online-class-list/:class_id' exact={true} render={(props) => <OnlineClassList {...props} />} />
						<Route path='/online-listings/:teacher_id' exact={true} render={(props) => <OnlineListings {...props} />} />
						<Route path='/teachers' exact={true} render={(props) => <AllTeachers {...props} />} />
						<Route path='/backdoor' render={(props) => <Backdoor {...props} />} />
						{/* <Route path='/test' component={Test}/> */}
					</Switch>

					{
						!parentInfoSaved && !parentInfoAlertClosedByUser ? (
							<div className='parentinfo-reminder'>
								<img onClick={this.closeParentInfoAlert} src={'https://www.flaticon.com/svg/static/icons/svg/1828/1828778.svg'} alt='close-icon'></img>
								<span>
									We have noticed that you have not specified your parent information yet. <Link to={'/profile'}>Click Here</Link> to add your parento information to your profile.
								</span>
							</div>
						) : null
					}

				</BrowserRouter>

			</div >
		);
	}
}
